let arrival_data4 = [
    {
        id : 12,
        imgurl : '/img/newarrival/section3_men5.jpg',
        brand : 'BROOKS BROTHERS',
        title : 'BB_스트레치 코튼 시어서커 슬림 치노 팬츠',
        persent : '20%',
        price : '165,000',
        saleprice : '132,000',
    },
    {
        id : 13,
        imgurl : '/img/newarrival/section3_men6.jpg',
        brand : 'LEVIS',
        title : 'DESTINATION TEE SEOUL',
        persent : '10%',
        price : '39,000',
        saleprice : '35,810',
    },
    {
        id : 14,
        imgurl : '/img/newarrival/section3_men7.jpg',
        brand : 'ILCORSO',
        title : '하트 아트웍 반팔 티셔츠 화이트',
        persent : '10%',
        price : '49,000',
        saleprice : '43,700',
    },
    {
        id : 15,
        imgurl : '/img/newarrival/section3_men8.jpg',
        brand : 'AMFEAST',
        title : 'Terry Buttons Summer Kintwear Black',
        persent : '13%',
        price : '89,000',
        saleprice : '77,430',
    },
]

export default arrival_data4